/// <reference types="vite/client" />
import { LoanActivity } from 'merchant-api/types';
import { queryOptions, useQuery, UseQueryResult } from '@tanstack/react-query';
import { spiceroad } from '..';

export interface UseActivity {
  isLoading: boolean;
  transactions: LoanActivity[] | undefined;
  isError: any;
  query: UseQueryResult<LoanActivity[]>;
}

const getTransactions = () =>
  spiceroad
    .get<LoanActivity[]>('/v1/loans/transactions')
    .then((res) => res.data);

export const getTransactionsOpts = queryOptions<LoanActivity[]>({
  queryKey: ['transactions'],
  queryFn: getTransactions,
  refetchOnMount: true,
  throwOnError: false
});
